document.addEventListener("DOMContentLoaded", function() {
  // Xóa tất cả các element có class này
  const listTrademarkEl = document.querySelectorAll(".salepify-fg-advanced__trademark");
  if(listTrademarkEl){
      listTrademarkEl.forEach(el => {
        el.remove();
      });
  }
});